import {getSamplesStream} from 'search/getSamplesStream.js';
import SamplesStream from 'track/SamplesStream.js';
import Sample from 'repos/Sample.js';

export const dropSampleTag = (sampleTagDragging, track, setSampleTagDragging, newSample) => {
    getSamplesStream(sampleTagDragging)
        .then(
            async r => {
                let sample = new Sample(r[0]);
                await sample.load();
                let samplesStream = new SamplesStream(
                    sample,
                    track.sequencerEngine);
                samplesStream.sounds = r.slice(1);
                newSample(sample, samplesStream);
                setSampleTagDragging(undefined);
                samplesStream.initBuffers();
            });
};
 
